import { useState, useEffect, useLayoutEffect } from 'react';
import './ASRVP-Card.css'


const ASRVPcard = (props) => {

    const [cardTextHeight, setCardTextHeight] = useState();
    const [cardStatusHeight, setCardStatusHeight] = useState();
    const [cardImageContainerHeight, setCardImageContainerHeight] = useState();
    const [cardChildrenContainerHeight, setCardChildrenContainerHeight] = useState();
    const [currentBreakpoint, setCurrentBreakpoint] = useState();

    useEffect(() => {
         //Run on component mount
        handleWindowResize();
        setHeight();

        // Add event listener for window resize
        window.addEventListener('resize', handleWindowResize);
       
        return () => {
             // Remove event listener on component unmount
            window.removeEventListener('resize', handleWindowResize);

        };
    }, []);

    useEffect(()=>{
        if(currentBreakpoint == "md"){
            resetHeight();
        }else{
            setHeight();
        }
    },[currentBreakpoint]);

    function setHeight() {
        handleCardTextHeight();
        handleCardStatusHeight();
        handleCardImageContainerHeight();
        handleCardChildrenContainerHeight();
    }

    function resetHeight() {
        setCardTextHeight("auto");
        setCardStatusHeight("auto");
        setCardImageContainerHeight("auto");
        setCardChildrenContainerHeight("auto");
    }

    function handleCardTextHeight() {
        updateHeightOfElement('asrvp-card-text', setCardTextHeight, cardTextHeight);
    }

    function handleCardStatusHeight() {
        updateHeightOfElement('asrvp-card-status', setCardStatusHeight, cardStatusHeight);
    }

    function handleCardImageContainerHeight() {
        updateHeightOfElement('asrvp-image-container', setCardImageContainerHeight, cardImageContainerHeight);
    }

    function handleCardChildrenContainerHeight() {
        updateHeightOfElement('asrvp-card-children', setCardChildrenContainerHeight, cardChildrenContainerHeight);
    }

    function updateHeightOfElement(className, updateMethod, heightState) {
        // Get all elements with the specific class name
        var elements = document.getElementsByClassName(className);

        // Initialize max height variable
        var maxHeight = 0;

        // Iterate over elements to find maximum height
        for (var i = 0; i < elements.length; i++) {
            // Temporarily remove the height style
            var prevHeight = elements[i].style.height;
            elements[i].style.height = "auto";

            // Measure the content's height using scrollHeight
            var elementHeight = elements[i].scrollHeight;

            // Update the max height
            maxHeight = Math.max(maxHeight, elementHeight);

            // Restore the previous height style
            elements[i].style.height = prevHeight;
        }
        // Update the height state with the maximum height
        updateMethod(() => maxHeight);
    }

    function getCurrentBreakpoint() {
        // Determine current breakpoint based on window width
        // You can replace these values with Bootstrap's actual breakpoints
        const width = window.innerWidth;
        if (width <= 992) {
            return 'md';
        } else if (width > 992 && width <= 1200) {
            return 'lg';
        } else if (width > 1200 && width <= 1400) {
            return 'xl';
        } else {
            return 'xxl';
        }
    }

    function handleWindowResize() {
        const newBreakpoint = getCurrentBreakpoint();
        setCurrentBreakpoint(newBreakpoint);
    }

    return (
        <div className={'asrvp-card container card ' + props.cardStatusType}>
            <div className='row'>
                <div className='asrvp-image-container container order-lg-2 order-2 col-md-4 col-lg-auto'
                style={{ height: cardImageContainerHeight != "auto" ? cardImageContainerHeight + "px" : "auto" }}
                >
                    <div className="asrvp-image">
                        {props.image}

                    </div>
                    <div className='asvp-image-text text-center mt-2'>
                        {props.imageText}
                    </div>
                </div>
                <div className="asrvp-card-text card-body asrvp-row text-center order-lg-1 order-1 col-md-8 col-lg-auto"
                style={{ height: cardTextHeight !== "auto" ? cardTextHeight + "px" : "auto" }}
                >
                    {props.text}
                </div>
                <div className='asrvp-card-status container text-center order-lg-3 order-3 mt-4'
                style={{ height: cardStatusHeight !== "auto" ? cardStatusHeight + "px" : "auto" }}
                >
                    {props.statusText}
                </div>
                <div className='asrvp-card-children container order-4 text-center mb-3'
                style={{ height: cardChildrenContainerHeight !== "auto" ? cardChildrenContainerHeight + "px" : "auto" }}
                >
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default ASRVPcard;